/**
 * 전화번호(휴대폰번호, FAX번호) 형식 검증
 */
const validateTelFormat = (tel: string): boolean => {
  const regex = /^0\d{1,2}-\d{3,4}-\d{4}$/;

  return regex.test(tel);
};

export default validateTelFormat;
